<template>
  <notification-inbox
    :loading="loading"
    :notifications="notifications"
    :selected-notification="selectedNotification"
    :current-page="pagination.currentPage"
    :total-pages="pagination.size"
    :unread-count="unreadCount"
    :theme="theme"
    :voted="selectedNotification ? !!votedById[selectedNotification.id] : false"
    :voting-busy="votingBusy"
    title="Minhas notificações"
    subtitle="Leia os comunicados e responda votações sem sair da caixa de entrada."
    @select="openNotification"
    @vote="vote"
    @page-change="getNotifications"
  />
</template>

<script>
import NotificationInbox from "@/components/notifications/NotificationInbox.vue";
import { classThemes } from "@/shared/classThemes";
import partnerApi from "@/shared/pitchPartnerApi";

export default {
  name: "NotificationsArea",

  components: {
    NotificationInbox,
  },

  data() {
    return {
      notifications: [],
      selectedId: null,
      loading: true,
      votingBusy: false,
      votedById: {},
      unreadCount: 0,
      pagination: {
        currentPage: 1,
        size: 1,
      },
    };
  },

  computed: {
    selectedNotification() {
      return (
        this.notifications.find((item) => item.id === this.selectedId) || null
      );
    },
    theme() {
      return classThemes.partner;
    },
  },

  mounted() {
    this.getNotifications();
  },

  methods: {
    async getNotifications(
      page = this.pagination.currentPage,
      preferredId = null
    ) {
      this.loading = true;
      this.pagination.currentPage = page;

      try {
        const res = await partnerApi.getNotifications(page);
        this.notifications = res.data?.notifications || [];
        this.pagination.size = Math.max(
          1,
          Math.ceil((res.data?.total || 0) / 10)
        );
        this.unreadCount = this.notifications.filter(
          (item) => !item.read
        ).length;
        this.syncSelection(preferredId);
      } catch {
        this.$root.$emit("display-alert", {
          text: "Ocorreu um problema ao carregar as suas notificações.",
          type: 1,
        });
      } finally {
        this.loading = false;
      }
    },
    syncSelection(preferredId = null) {
      if (!this.notifications.length) {
        this.selectedId = null;
        return;
      }

      const match = this.notifications.find((item) => item.id === preferredId);
      this.selectedId = (match || this.notifications[0]).id;
    },
    async openNotification(item) {
      this.selectedId = item.id;

      if (!item.read) {
        try {
          await partnerApi.readNotification(item.id);
          item.read = true;
          this.unreadCount = this.notifications.filter(
            (entry) => !entry.read
          ).length;
        } catch {
          this.$root.$emit("display-alert", {
            text: "Ocorreu um problema ao ler a notificação.",
            type: 1,
          });
        }
      }
    },
    async vote({ voteId, option }) {
      const currentId = this.selectedId;
      this.votingBusy = true;

      try {
        await partnerApi.vote(voteId, option);
        this.$set(this.votedById, currentId, true);
        this.$root.$emit("display-alert", {
          text: "Opiniao registrada com sucesso!",
          type: 0,
        });
        await this.getNotifications(this.pagination.currentPage, currentId);
      } catch (err) {
        this.$root.$emit("display-alert", {
          text:
            err?.response?.data?.message ||
            "Votacao ja encerrada ou indisponivel.",
          type: 1,
        });
      } finally {
        this.votingBusy = false;
      }
    },
  },
};
</script>
